import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-8 lg:py-16 xl:py-32 max-w-container px-container" }
const _hoisted_2 = {
  to: { name: 'events', params: { type: 'movies' } },
  class: "mb-14 lg:grid grid-cols-2"
}
const _hoisted_3 = { class: "mb-10 mt-14 max-w-xl" }
const _hoisted_4 = { class: "lg:ml-16" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "mb-3 lg:mt-12 text-2xl lg:text-3xl xl:text-4xl font-bold" }, " Movies. ", -1)
const _hoisted_6 = { class: "lg:ml-9 text-lg xl:text-2xl" }
const _hoisted_7 = { class: "mb-6 font-thin" }
const _hoisted_8 = {
  to: { name: 'events', params: { type: 'music' } },
  class: "mb-14 lg:grid grid-cols-2"
}
const _hoisted_9 = { class: "mb-10 mt-14 max-w-xl order-2" }
const _hoisted_10 = { class: "lg:ml-16" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", { class: "mb-3 lg:mt-12 text-2xl lg:text-3xl xl:text-4xl font-bold" }, " Music. ", -1)
const _hoisted_12 = { class: "lg:ml-9 text-lg xl:text-2xl" }
const _hoisted_13 = { class: "mb-6 font-thin" }
const _hoisted_14 = {
  to: { name: 'events', params: { type: 'talks' } },
  class: "mb-14 lg:grid grid-cols-2"
}
const _hoisted_15 = { class: "mb-10 mt-14 max-w-xl" }
const _hoisted_16 = { class: "lg:ml-16" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h2", { class: "mb-3 lg:mt-16 text-2xl lg:text-3xl xl:text-4xl font-bold" }, " Talks. ", -1)
const _hoisted_18 = { class: "lg:ml-9 text-lg xl:text-2xl" }
const _hoisted_19 = { class: "mb-6 font-thin" }
const _hoisted_20 = {
  to: { name: 'professionals-talents' },
  class: "mb-14 lg:grid grid-cols-2"
}
const _hoisted_21 = { class: "mb-10 mt-14 max-w-xl order-2" }
const _hoisted_22 = { class: "lg:ml-16" }
const _hoisted_23 = /*#__PURE__*/_createVNode("h2", { class: "mb-3 lg:mt-12 text-2xl lg:text-3xl xl:text-4xl font-bold" }, " Mallorca Talents Lab. ", -1)
const _hoisted_24 = { class: "lg:ml-9 text-lg xl:text-2xl" }
const _hoisted_25 = { class: "mb-6 font-thin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_StickerFrame = _resolveComponent("StickerFrame")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, { class: "mb-6" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("home.discover_this_years_content")), 1)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_StickerFrame, {
          text: "Movies.",
          imageSrc: `${_ctx.baseURL}img/home/movies/movie.jpg?date=2023-05-31`
        }, null, 8, ["imageSrc"])
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("home.overview_movies")), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_StickerFrame, {
          text: "Music.",
          imageSrc: `${_ctx.baseURL}img/home/music/music-section.jpg?date=2023-05-31`,
          rotateDirection: "right"
        }, null, 8, ["imageSrc"])
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("home.overview_music")), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_StickerFrame, {
          text: "Talks.",
          imageSrc: `${_ctx.baseURL}img/home/talks/talk.jpg?date=2023-05-31`
        }, null, 8, ["imageSrc"])
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode("div", _hoisted_18, [
          _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("home.overview_talks")), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode(_component_StickerFrame, {
          text: "Talents Lab.",
          imageSrc: `${_ctx.baseURL}img/home/talents-lab/talent.jpg?date=2022-05-31`,
          rotateDirection: "right"
        }, null, 8, ["imageSrc"])
      ]),
      _createVNode("div", _hoisted_22, [
        _hoisted_23,
        _createVNode("div", _hoisted_24, [
          _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("home.overview_talents_lab")), 1)
        ])
      ])
    ])
  ]))
}